import mapboxgl from 'mapbox-gl'
import { useEffect, useMemo, useState } from 'react'
import { useMapboxContext } from '../map/context'
import { assign } from 'lodash-es'

export default function useMarker({ lng, lat, id, element, opts }) {

  const { map, mapLoaded } = useMapboxContext()
  const [marker, setMarker] = useState()
  const box = useMemo(() => {
    if (element) {
      const d = document.createElement('div')
      d.setAttribute('id', `marker-${id}`)
      return d
    }
  }, [element, id])

  useEffect(() => {
    if (!mapLoaded || !lng || !lat) return

    if (marker) {
      marker.setLngLat([lng, lat])
    } else {
      const marker = addMarker(map, lng, lat, assign(opts, { element: box }))
      marker.id = id
      setMarker(marker)
    }
  }, [lng, lat, mapLoaded, map, box, opts, marker, id])

  useEffect(() => {
    return () => {
      removeMarker(marker)
    }
  }, [marker])

  return {
    marker,
    box
  }
}

export function addMarker(map, lng, lat, opts) {
  if (!map || !lng || !lat) return null

  return new mapboxgl.Marker(opts).setLngLat([lng, lat]).addTo(map)
}
export function removeMarker(marker) {
  if (marker) marker.remove()
}